// extracted by mini-css-extract-plugin
export default {"content":"style_content__xj4M7","checkbox":"style_checkbox__AccO8"};